import { render, staticRenderFns } from "./AlarmPointManagerDialog.vue?vue&type=template&id=178b4097"
import script from "./AlarmPointManagerDialog.vue?vue&type=script&lang=ts"
export * from "./AlarmPointManagerDialog.vue?vue&type=script&lang=ts"
import style0 from "./AlarmPointManagerDialog.vue?vue&type=style&index=0&id=178b4097&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports